import {
    AnyFinancialEntity,
    getCurrentValue,
    isAsset,
    isPlentyGoalAccount,
} from '../financialEntities';
import { sum } from '../util/arrays';
import { assetsFromFEs, debtsFromFEs, FEsData } from './financialEntities';
import { getGoalBalance } from './goals';

export const getNetWorthInfo = ({ fesData }: { fesData: FEsData }) => {
    const assets = assetsFromFEs(fesData.financialEntities);
    const debts = debtsFromFEs(fesData.financialEntities);

    const assetsTotal = sum(assets, getCurrentValue);
    const debtsTotal = sum(debts, getCurrentValue);
    const goalsTotal = sum(fesData.goals, getGoalBalance);

    const netWorth = assetsTotal + goalsTotal - debtsTotal;

    const positiveAccounts: AnyFinancialEntity[] = [];
    const negativeAccounts: AnyFinancialEntity[] = [];
    fesData.financialEntities.forEach((fe) => {
        if (isPlentyGoalAccount(fe)) {
            positiveAccounts.push(fe);
        } else if (isAsset(fe)) {
            positiveAccounts.push(fe);
        } else {
            negativeAccounts.push(fe);
        }
    });

    return {
        netWorth,
        change: {
            positiveAccounts,
            negativeAccounts,
        },
    };
};

export const getPlentyTotalInfo = ({ fesData }: { fesData: FEsData }) => {
    const plentyTotal = sum(fesData.goals, getGoalBalance);

    const positiveAccounts: AnyFinancialEntity[] = [];
    const negativeAccounts: AnyFinancialEntity[] = [];
    fesData.financialEntities.forEach((fe) => {
        if (isPlentyGoalAccount(fe)) {
            positiveAccounts.push(fe);
        }
    });

    return {
        plentyTotal,
        change: {
            positiveAccounts,
            negativeAccounts,
        },
    };
};
